// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';
// --_CCC
Array.prototype.remove = function (from, to) {
    var rest = this.slice((to || from) + 1 || this.length);
    this.length = from < 0 ? this.length + from : from;
    return this.push.apply(this, rest);
};

var ModalConfirmDeleteEntityCtrl = function ($scope, $modalInstance, $http, id, title, description, delete_all, isInTransaction) {    
    $scope.title = title;
    $scope.description = description;

    var deletionParameter = $.param({
        isInTransaction: isInTransaction
    });

    $scope.delete = function () {
        if (delete_all)
            $http.delete('/api/v1/entities/' + id + "?" + deletionParameter)
                .success(
                function () {
                    alert("Entity successfully deleted");
                    window.location = "/#/entities";
                });
        else
            $http.delete('/api/v1/entities/' + id + "/customers?" + deletionParameter)
                .success(
                    function () {
                        alert("Cleanup successful");
                    });

        $modalInstance.close();
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};

var ModalConfirmEntityCtrl = function ($scope, $modalInstance, title, description, confirmCallback, cancelCallback) {
    $scope.title = title;
    $scope.description = description;

    $scope.confirm = function () {
        confirmCallback();
        $modalInstance.close();
    };
    $scope.cancel = function () {
        if (cancelCallback) {
            cancelCallback();
        }
        $modalInstance.dismiss('cancel');
    };
};

